// extracted by mini-css-extract-plugin
export var root = "ContactInfo-root-SXCn+";
export var rootCol = "ContactInfo-root_col-LGuiF";
export var rootDescription = "ContactInfo-root_description-3Pfmt";
export var rootIcon = "ContactInfo-root_icon-bjZKw";
export var rootTitle = "ContactInfo-root_title-DDF7t";